<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="group_work"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $t('price_groups') }}
        </div>
      </template>

      <v-row class="mx-0">
        <v-col cols="6">
          <filter-main
            :filter-options="filterOptions"
            :filter-actions="filterActions"
            :filter="filter"
            @set-filter="setFilter"
          />
        </v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
          @blur="getDataFromApi"
          @keydown.enter="getDataFromApi"
        />
      </v-row>

      <v-divider class="my-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        dense
        class="elevation-1"
      >
        <template v-slot:header.customers_count="{}">
          <v-icon>
            fas fa-users
          </v-icon>
        </template>
        <template v-slot:header.prices_count="{}">
          <v-icon>
            fas fa-boxes
          </v-icon>
        </template>
        <template v-slot:item.customers_count="{ item }">
          <div :class="!item.customers_count && 'red--text'">
            {{ item.customers_count }}
          </div>
        </template>
        <template v-slot:item.prices_count="{ item }">
          <div :class="!item.prices_count && 'red--text'">
            {{ item.prices_count }}
          </div>
        </template>
        <template v-slot:item.sales_price_percentage="{ item }">
          <div>
            {{ item.sales_price_percentage }} %
          </div>
        </template>
        <template v-slot:item.sales_price_surcharge="{ item }">
          <div>
            {{ item.sales_price_surcharge }} ,-
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            medium
            color="orange"
            class="mr-2"
            @click="duplicateItem(item)"
          >
            mdi-book-multiple
          </v-icon>
          <v-icon
            medium
            class="mr-2"

            color="green"
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            medium
            color="red"
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <v-col>
        <v-row>
          <v-btn
            color="green"
            class="ml-auto mt-5"
            @click="editItem({id: null})"
          >
            <v-icon class="mr-3">
              mdi-plus
            </v-icon>
            {{ $t('new') }}
          </v-btn>
        </v-row>
      </v-col>
    </base-material-card>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'
  import { SUPERUSER, SUPPORT } from '../../../utils/constants'

  export default {
    mixins: [List],

    data () {
      return {
        name: 'price_group',
        endpoint: 'price-groups/overview',
        crudl: {
          C: SUPERUSER.val,
          R: SUPERUSER.val,
          U: SUPERUSER.val,
          D: SUPERUSER.val,
          L: SUPPORT.val,
        },
        headers: [
         {
            sortable: false,
            text: this.$t('id'),
            value: 'id'
          },
          {
            sortable: false,
            text: this.$t('name'),
            value: 'name',
            width: '100%',

          },
          {
            sortable: false,
            value: 'customers_count',
            align: 'center',

          },
          {
            sortable: false,
            value: 'prices_count',
            align: 'center',
          },
          {
            text: `${this.$t('fee')} %`,
            value: 'sales_price_percentage',
          },
          {
            text: this.$t('fee'),
            value: 'sales_price_surcharge',
          },
          {
            text: this.$t('sales_price'),
            value: 'sales_price',
          },
          { text: this.$t('actions'), value: 'action', sortable: false },

        ],
        editedItem: {
          name: '',
          slug: '',
          erp_id: '',
          volume_weight_factor: '',
        },
        defaultItem: {
          name: '',
          slug: '',
          erp_id: '',
          volume_weight_factor: '',
        },
      }
    },
    methods: {
      editItem: function ({ id }) {
        this.$router.push(`/price-groups/${id}`)
      },
      duplicateItem ({ id }) {
        if (confirm(this.$t('confirm_duplicate', { type: this.$t(this.name).toLowerCase() }))) {
          this.$post(`/price-groups/${id}/duplicate`).then(r => {
            this.getDataFromApi()

            this.$toast(`${this.$t(this.name)} ${this.$t('duplication_correctly')}`)
          })
        }
      },
      deleteItem (item) {
        if (!this.canDelete()) { return }

        const index = this.$_.findIndex(this.items, c => c.id === item.id)

        if (confirm(this.$t('confirm_delete', { type: this.$t(this.name).toLowerCase() }))) {
          if (index >= 0) {
            this.$del(`/price-groups/${item.id}`, undefined, { useDev: this.useDev }).then(() => {
              this.items.splice(index, 1)
              this.$toast(`${this.$t(this.name)} ${this.$t('has_been_deleted')}`)
            })
          }
        }
      },
    },
  }
</script>
